import { useNavigate } from "react-router-dom";


export default function BannerSlide() {

  return (
    <div className="flex justify-center h-full flex-col">
      <h1 className="text-purple-900 font-extrabold max-w-3xl text-2xl lg:text-5xl font-nunito">AI IN HEALTHCARE: HOW PATIENTS, CAREGIVERS & CLINICIANS USE AI TODAY</h1>

      <h4 className="text-[#E85D04] mt-4 text-xl lg:text-3xl max-w-4xl">Qualitative Insights from 60-Minute Interviews on Information Seeking, Trust, Communication & Decision-Making</h4>
    </div>
  );
}
